
$(window).on("load", function() {
    $.post(site_url + "ajax/functions.php", {
        operation: ajax_map_operation,
        map_image_size: (typeof map__image_size === undefined ? map__image_size : "thumbnail"),
        hotel_pin_image: hotel_image_thumbnail,
        hotel_pin_icon: hotel_pin_icon,
        map_pin_icon: icon,
    }, function (data) {

        initializeMap(data.config.map_latitude, data.config.map_longitude, data.config.map_zoom);

        //LOAD PINS IN MAP

        //Set Hotel Pin
        const hotel_marker = {
            id: 0,
            // name: data.hotel.name,
            name: data.hotel.name,
            description: data.hotel.description,
            thumb: data.hotel.thumb,
            lat: data.hotel.lat,
            long: data.hotel.long,
            url: data.hotel.url,
            icon: data.hotel.icon,
        };

        loadMarker(hotel_marker);

        const pins = data.pins;
        const number_of_pins = Object.keys(pins);

        for (let index = 1; index <= number_of_pins.length; ++index) {
            let pin = pins[index];
            loadMarker(pin);
        }

        //LOAD PINS IN SLIDER
        if (map_sidebar) {
            let map_pins_markup = `
                        <div class="map-pin">
                            ${ hotel_marker.thumb !== "" ? `<img src="${hotel_marker.thumb}" alt="${hotel_marker.name} Photo" class="img-responsive">` : ""}
                            <div class="info-wrapper">
                                <h2>${hotel_marker.name}</h2>
                                <p>${hotel_marker.description}</p>
                                ${ hotel_marker.url !== "" ? `<a target="_blank" class="btn" href="${hotel_marker.url}">${ pin_button_label }</a>` : ""}
                            </div>
                        </div>`;

            for (let index = 1; index <= number_of_pins.length; ++index) {
                let pin = pins[index];
                map_pins_markup += `
                        <div class="map-pin">
                            ${ pin.thumb !== "" ? `<img src="${pin.thumb}" alt="${pin.name} Photo" class="img-responsive">` : ""}
                            <div class="info-wrapper">
                                <h2>${pin.name}this${pin.url}</h2>
                                ${ pin.walking !== "" ? `<h3 class="walking-distance">${ pin.walking }</h3>` : ""}
                                ${ pin.biking !== "" ? `<h3 class="biking-distance">${ pin.biking }</h3>` : ""}
                                ${ pin.driving !== "" ? `<h3 class="driving-distance">${ pin.driving }</h3>` : ""}
                                <p>${pin.description}</p>
                                ${ pin.url !== "" ? `<a target="_blank" class="btn" href="${pin.url}">${ pin_button_label }</a>` : ""}
                            </div>
                        </div>`;
            }

            slick_pins.html(map_pins_markup);
            slick_pins.slick();
            setTimeout(() => equalize(), 0);
        }
        $("#map---overall-wrapper").css("opacity", "1")

    }, "json");

    function triggerClick(i) {
    google.maps.event.trigger(infowindow, "closeclick");
    google.maps.event.trigger(markerList[i], "click");
    map.panTo(markerList[i].getPosition());
    map.setZoom(15);
}

    slick_pins.on('afterChange', function(event, slick, currentSlide, nextSlide){
      triggerClick(currentSlide);
    });
    
});